module.exports = __webpack_public_path__ + "img/provider3.5ca53f8c.png";